import React from "react";

import {Typography} from "@mui/material";
import {typografNode} from "../../utils/typograf";
import {SxProps} from "@mui/material/styles";

type IntroSubtitleProps = {
    children: React.ReactNode;
    sx?: SxProps;
};

function IntroSubtitle({children, sx}: IntroSubtitleProps) {
    return (
        <Typography sx={[{
            fontWeight: '700',
            textTransform: 'uppercase',
            fontFamily: 'Source Code Pro, Roboto, sans-serif',
            columnGap: '16px',
            '@media screen and (min-width: 1400px)': {
                fontSize: '20px',
                lineHeight: 1.6,
                letterSpacing: '4px',
            },
            '@media screen and (min-width: 1200px) and (max-width: 1399px)': {
                fontSize: '20px',
                lineHeight: 1.6,
                letterSpacing: '4px',
            },
            '@media screen and (min-width: 992px) and (max-width: 1199px)': {
                fontSize: '16px',
                lineHeight: 1.63,
                letterSpacing: '3.2px',
                columnGap: '14px',
            },
            '@media screen and (min-width: 768px) and (max-width: 1199px)': {
                fontSize: '16px',
                lineHeight: 1.6,
                letterSpacing: '3.2px',
                columnGap: '12px',
            },
            '@media screen and (max-width: 767px)': {
                fontSize: '12px',
                lineHeight: 1.67,
                letterSpacing: '2.4px',
                columnGap: '10px'
            },
            '@media screen and (max-width: 575px)': {
                lineHeight: 1.6,
                letterSpacing: '0.2em',
                columnGap: '12px',
            },
        }, ...(Array.isArray(sx) ? sx : [sx ?? false])]}>
            {typografNode(children)}
        </Typography>
    );
}

export default IntroSubtitle
